var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.024,
    height: 12.036,
    viewBox: "0 0 67.024 12.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267",
    transform: "translate(-221.125 -761.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M236.208,771.459v-7.715h4.1V765h-2.632v1.928h2.376v1.236h-2.376V770.2h2.632v1.257Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M248.271,771.459l-.544-4.912c-.053-.48-.074-1.045-.074-1.045h-.022s-.106.555-.255,1.045l-1.46,4.912h-.959l-1.471-4.912c-.149-.49-.255-1.045-.255-1.045h-.022s-.021.565-.074,1.045l-.544,4.912h-1.4l.96-7.715h1.7l1.343,4.508c.128.447.224.991.224.991h.021s.1-.544.224-.991L247,763.744h1.7l.959,7.715Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M250.786,771.459v-7.715h1.5v7.715Z",
    fill: "#23b6bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M263.206,764.59v.463h-7.7v-.463h3.268v-.373c0-.1-.025-.38-.025-.471l1.158.016a.1.1,0,0,1,.058.1.658.658,0,0,1-.033.173v.555Zm-.364,3.11v2.871c0,.621-.149.86-.943.86h-1.258l-.182-.521a7.273,7.273,0,0,0,.82.058c.33,0,.413-.025.413-.355v-2.449h-4.7V771.5h-1.142v-3.8Zm-.984-2.151v1.663h-5.006v-1.663Zm-.819,3.152v1.9h-3.4v-1.9Zm-3.061-2.688v.769h2.746v-.769Zm.728,3.152v.968h1.257v-.968Z",
    fill: "#717071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M265.762,766.112a5.686,5.686,0,0,0-.347-1.15H265.2a9.135,9.135,0,0,1-1.175,1.076l-.406-.257a4.58,4.58,0,0,0,1.167-2.11l1.133.29c.017.008.05.017.05.058s-.025.066-.1.132a2.894,2.894,0,0,0-.273.356h1.952v.455h-1.365a6.893,6.893,0,0,1,.761.769Zm2.416,1.44h3.309v.463h-7.7v-.463h3.268v-.828h-2.54v-.463h2.54c0-.19-.017-.372-.033-.554l1.158.024a.13.13,0,0,1,.041.083.842.842,0,0,1-.041.141v.306H270.7v.463h-2.523Zm.4.868a.94.94,0,0,0-.033-.306l1.125.066c.1.009.133.066.133.1,0,.058-.025.091-.091.232v.356h1.77v.463h-1.77v1.216c0,.728-.224.894-.935.894H267.26l-.182-.513a9.39,9.39,0,0,0,1.108.083c.331,0,.4-.075.4-.439V769.33h-3.218a10.3,10.3,0,0,1,1.622,1.067l-1.051.786a7.876,7.876,0,0,0-1.026-1.58l.323-.273h-1.448v-.463h4.8Zm.927-2.325a5.607,5.607,0,0,0-.447-1.133h-.4a7.214,7.214,0,0,1-.827.745l-.4-.232a3.461,3.461,0,0,0,.852-1.8l1.125.29c.033.017.033.033.033.05,0,.074-.083.132-.132.165-.1.132-.141.19-.249.331h2.416v.455H269.9a8.406,8.406,0,0,1,.877.745Z",
    fill: "#717071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M279.76,768.776v.463h-3.285V770.6c0,.687-.289.877-.967.877H274.06l-.141-.529a7.044,7.044,0,0,0,.918.074c.381,0,.464-.049.464-.43v-1.357h-3.243v-.463H275.3v-.9l.835.066a5.139,5.139,0,0,0,.679-.753H273.5v-.455h4.823v.579a15.107,15.107,0,0,1-1.845,1.126v.339Zm-4.41-3.342a6.81,6.81,0,0,0-.57-1.5l.43-.256a7.824,7.824,0,0,1,1.332,1.29l-.836.464h1.886l-.479-.232a4.709,4.709,0,0,0,.587-1.506l1.282.505a.045.045,0,0,1,.025.041.233.233,0,0,1-.174.174,11.186,11.186,0,0,1-1.183,1.018h1.92v1.6h-1.134v-1.141h-5.088v1.158h-1.117v-1.613h1.2a9.01,9.01,0,0,0-.728-1.374l.4-.273a5.588,5.588,0,0,1,1.506,1.183l-.687.464Z",
    fill: "#717071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M282.324,766.931a4.1,4.1,0,0,1,.778,2.259c0,1.092-.621,1.092-.869,1.092h-.5l-.166-.571a.787.787,0,0,0,.265.049c.107,0,.306,0,.306-.719a4.531,4.531,0,0,0-.579-2.06l.612-2.482h-.711v6.99h-1v-7.445h2.813v.471l-.074.19h1.7v-.446a4.765,4.765,0,0,0-.025-.5l1.125.008c.058,0,.141.025.141.108s-.058.108-.107.132v.7h1.878v1.655h-.687v.381H283.8v-.381h-.67v-1.472Zm4.253,3.748c0,.24.016.281.239.281.315,0,.373-.05.406-.149a4.669,4.669,0,0,0,.074-.927,2.069,2.069,0,0,0,.853.282c-.149,1.075-.356,1.241-1.01,1.241h-.885c-.745,0-.8-.24-.8-.753v-2.375h-.413a2.842,2.842,0,0,1-2.466,3.244l-.322-.373c1.456-.471,1.737-1.224,1.7-2.871h-.86v-.455h4.889v.455h-1.406Zm-2.4-4.4H286.8v-1.108h-2.623Z",
    fill: "#717071"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M226.914,772.533a1.177,1.177,0,0,0,.436-.927l-.01-3.952a1.1,1.1,0,0,0-.127-.483l-.741.395v5.058A.812.812,0,0,0,226.914,772.533Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M230.76,765.278a1.119,1.119,0,0,1,.115.461v4.941c0,.365.215.54.478.39a1.166,1.166,0,0,0,.479-.935v-4.949a1.093,1.093,0,0,0-.1-.428Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M229.114,766.679v5.032c0,.365.216.527.479.36a1.255,1.255,0,0,0,.479-.966v-4.98a1.091,1.091,0,0,0-.1-.427l-.974.519A1.108,1.108,0,0,1,229.114,766.679Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M227.34,767.654l.01,3.952a1.177,1.177,0,0,1-.436.927.812.812,0,0,1-.442.091v1.088a1.152,1.152,0,0,0,.582-.144l.689-.417a1.3,1.3,0,0,0,.566-1.006l-.012-5.055a1.058,1.058,0,0,0-.108-.44l-.976.521A1.1,1.1,0,0,1,227.34,767.654Z",
    fill: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M231.264,764.2l-4.122-2.372a1.2,1.2,0,0,0-1.058-.056c-.266.151-.226.423.09.6l4.132,2.377a1.223,1.223,0,0,1,.455.522l.974-.52A1.242,1.242,0,0,0,231.264,764.2Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M229.5,765.142,225.43,762.8a1.194,1.194,0,0,0-1.058-.057c-.266.151-.225.423.091.6l4.081,2.348a1.23,1.23,0,0,1,.455.522l.974-.52A1.234,1.234,0,0,0,229.5,765.142Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M227.72,766.115l-4.109-2.29a1.22,1.22,0,0,0-1.067-.046c-.268.152-.227.421.091.6l4.129,2.3a1.194,1.194,0,0,1,.448.492l.976-.521A1.2,1.2,0,0,0,227.72,766.115Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M225.926,772.467l-3.27-1.89a1.275,1.275,0,0,1-.574-.994v-2.721c0-.365.26-.517.578-.338l2.276,1.278a1.254,1.254,0,0,1,.577.987v.229c0,.364-.258.512-.573.329l-.991-.578c-.315-.183-.573-.068-.573.257a1.188,1.188,0,0,0,.578.914l1.936,1.086c.318.178.578.026.579-.338l0-2.459a1.239,1.239,0,0,0-.579-.983l-4.187-2.313a.359.359,0,0,0-.58.343v4.859a1.276,1.276,0,0,0,.573.995l4.239,2.45a1.146,1.146,0,0,0,.535.133v-1.089A1.254,1.254,0,0,1,225.926,772.467Z",
    fill: "#23b6bc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.747154cbf207aec74cbac442aa8ff750.svg";
export { ForwardRef as ReactComponent };